import React__default from 'react';
import PropTypes from 'prop-types';
import Container from '../../node_modules/reactstrap/esm/Container.js';
import Row from '../../node_modules/reactstrap/esm/Row.js';
import { FooterElement, FooterSection, FooterSectionTop, FooterSectionHeader, FooterSectionContent, FooterSectionList, FooterCopyright } from './FooterElements.js';
import { optionsFor as optionsFor$1, footerOptions as footerOptions$1 } from './footerOptions.js';
import last from '../../node_modules/ramda/es/last.js';

var isArray = Array.isArray;
var FooterComp = function FooterComp(_ref) {
  var sections = _ref.sections,
    copyright = _ref.copyright;
  return /*#__PURE__*/React__default.createElement(FooterElement, null, /*#__PURE__*/React__default.createElement(Container, null, /*#__PURE__*/React__default.createElement(Row, null, sections.map(function (_ref2) {
    var id = _ref2.id,
      title = _ref2.title,
      options = _ref2.options;
    return /*#__PURE__*/React__default.createElement(FooterSection, {
      key: id
    }, /*#__PURE__*/React__default.createElement(FooterSectionTop, null, /*#__PURE__*/React__default.createElement(FooterSectionHeader, null, title), /*#__PURE__*/React__default.createElement(FooterSectionContent, null, isArray(options) ? /*#__PURE__*/React__default.createElement(FooterSectionList, {
      list: options
    }) : options)), last(sections).id === id ? /*#__PURE__*/React__default.createElement(FooterCopyright, null, copyright) : null);
  }))));
};
FooterComp.displayName = "PGAFooter";
FooterComp.propTypes = {
  sections: PropTypes.array.isRequired,
  copyright: PropTypes.string
};
var optionsFor = optionsFor$1;
var footerOptions = footerOptions$1;
var Footer = FooterComp;

export { Footer, footerOptions, optionsFor };
